var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaigntrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 292,
    viewBox: "0 0 384 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_27548)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 292,
    rx: 16,
    fill: "#9700BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.722 73.7888L90.0076 93.0979C85.9023 93.5294 82.9223 97.1895 83.3515 101.273L95.6073 297.466C96.0365 301.55 99.7124 304.51 103.818 304.079L283.77 285.165C287.876 284.734 290.856 281.074 290.426 276.99L281.932 80.4012C281.503 76.3178 277.827 73.3573 273.722 73.7888Z",
    fill: "black",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_871_27548)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.723 73.7888L90.0085 93.0979C85.9032 93.5294 82.9231 97.1894 83.3523 101.273L102.67 285.066C103.099 289.149 106.775 292.11 110.88 291.678L294.594 272.369C298.699 271.938 301.679 268.278 301.25 264.194L281.933 80.4012C281.504 76.3178 277.828 73.3573 273.723 73.7888Z",
    fill: "#FFFAF0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_871_27548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_871_27548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 65,
    width: 234,
    height: 233
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M284.269 65.6944L85.3643 86.6168C81.6822 87.0041 79.0162 90.3011 79.4097 93.9807L100.509 291.301C100.903 294.981 104.206 297.65 107.889 297.262L306.793 276.34C310.476 275.953 313.142 272.656 312.748 268.976L291.649 71.6557C291.255 67.9761 287.951 65.3071 284.269 65.6944Z",
    fill: "#FFFAF0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_871_27548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.698 76.0138L299.845 267.703L107.322 287.938L87.1748 96.2488L279.698 76.0138ZM109.099 285.754L297.653 265.936L277.921 78.1986L89.3673 98.0164L109.099 285.754Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.142 95.3595L125.082 285.073L123.097 285.282L103.157 95.5681L105.142 95.3595Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.02 93.6906L140.96 283.404L138.975 283.613L119.035 93.8992L121.02 93.6906Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.899 92.0216L156.839 281.735L154.854 281.944L134.914 92.2302L136.899 92.0216Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.777 90.3529L172.716 280.066L170.732 280.275L150.792 90.5615L152.777 90.3529Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.655 88.684L188.594 278.397L186.61 278.606L166.67 88.8926L168.655 88.684Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.533 87.015L204.472 276.729L202.488 276.937L182.548 87.2236L184.533 87.015Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.412 85.3463L220.351 275.06L218.366 275.268L198.427 85.5549L200.412 85.3463Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.289 83.6774L236.229 273.391L234.244 273.599L214.305 83.886L216.289 83.6774Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.167 82.0084L252.107 271.722L250.122 271.931L230.183 82.217L232.167 82.0084Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.046 80.3395L267.986 270.053L266.001 270.262L246.062 80.5481L248.046 80.3395Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.924 78.6708L283.864 268.384L281.879 268.593L261.939 78.8794L263.924 78.6708Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.575 93.9037L90.0365 113.93L89.8288 111.954L280.367 91.9275L280.575 93.9037Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.237 109.713L91.6987 129.74L91.491 127.763L282.029 107.737L282.237 109.713Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.898 125.523L93.3598 145.549L93.1521 143.573L283.69 123.546L283.898 125.523Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.56 141.332L95.0219 161.359L94.8142 159.382L285.353 139.356L285.56 141.332Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.222 157.141L96.684 177.168L96.4763 175.192L287.015 155.165L287.222 157.141Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.883 172.951L98.3451 192.977L98.1374 191.001L288.676 170.975L288.883 172.951Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.546 188.76L100.007 208.787L99.7995 206.811L290.338 186.784L290.546 188.76Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.207 204.57L101.668 224.596L101.461 222.62L291.999 202.594L292.207 204.57Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.869 220.38L103.33 240.406L103.123 238.43L293.661 218.403L293.869 220.38Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53 236.189L104.992 256.215L104.784 254.239L295.322 234.213L295.53 236.189Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.192 251.998L106.654 272.025L106.446 270.049L296.984 250.022L297.192 251.998Z",
    fill: "#9700BC",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.981 182.77C188.671 182.698 189.256 182.885 189.288 183.189C189.319 183.492 188.787 183.797 188.096 183.869L121.448 190.874C120.758 190.947 120.174 190.76 120.142 190.456C120.11 190.152 120.643 189.848 121.333 189.775L187.981 182.77Z",
    fill: "#9700BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.888 200.917C190.578 200.844 191.163 201.031 191.195 201.335C191.227 201.639 190.694 201.943 190.004 202.016L123.356 209.021C122.665 209.094 122.081 208.906 122.049 208.603C122.017 208.299 122.55 207.994 123.24 207.922L189.888 200.917Z",
    fill: "#9700BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.795 219.063C192.486 218.991 193.07 219.178 193.102 219.482C193.134 219.785 192.601 220.09 191.911 220.162L125.263 227.167C124.573 227.24 123.988 227.053 123.956 226.749C123.924 226.445 124.457 226.141 125.147 226.068L191.795 219.063Z",
    fill: "#9700BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.703 237.21C194.393 237.137 194.977 237.324 195.009 237.628C195.041 237.932 194.508 238.236 193.818 238.309L127.17 245.314C126.48 245.386 125.895 245.199 125.863 244.896C125.832 244.592 126.364 244.287 127.055 244.215L193.703 237.21Z",
    fill: "#9700BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61 255.356C196.3 255.284 196.885 255.471 196.916 255.775C196.948 256.079 196.416 256.383 195.725 256.456L129.077 263.461C128.387 263.533 127.803 263.346 127.771 263.042C127.739 262.739 128.272 262.434 128.962 262.361L195.61 255.356Z",
    fill: "#9700BC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_871_27548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.911 98.6558L187.041 129.867L195.805 171.1L281.962 152.787L273.198 111.553L233.215 95.1902C223.467 91.8972 224.905 91.3768 216.911 98.6558Z",
    fill: "#DF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.264 91.7277L188.835 107.336C187.754 107.565 187.064 108.631 187.294 109.715L198.352 161.736C198.582 162.82 199.646 163.513 200.727 163.283L274.156 147.675C275.237 147.445 275.927 146.38 275.697 145.296L264.639 93.2745C264.409 92.1904 263.345 91.4978 262.264 91.7277Z",
    fill: "#FFF3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.377 104.054L208.241 111.097C208.14 111.119 208.042 111.067 208.024 110.982L207.904 110.418C207.886 110.333 207.954 110.246 208.056 110.224L241.192 103.181C241.293 103.159 241.391 103.211 241.409 103.297L241.529 103.86C241.547 103.945 241.479 104.033 241.377 104.054Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.746 110.452L209.61 117.496C209.509 117.517 209.411 117.465 209.393 117.38L209.273 116.817C209.255 116.731 209.323 116.644 209.425 116.622L242.561 109.579C242.662 109.558 242.76 109.61 242.778 109.695L242.898 110.258C242.916 110.344 242.848 110.431 242.746 110.452Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.555 137.444L205.611 146.359C205.497 146.383 205.387 146.325 205.366 146.229L205.255 145.704C205.234 145.608 205.311 145.51 205.425 145.486L247.37 136.57C247.484 136.546 247.594 136.605 247.614 136.7L247.726 137.225C247.746 137.321 247.669 137.419 247.555 137.444Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.038 144.43L207.093 153.346C206.979 153.37 206.869 153.312 206.849 153.216L206.737 152.691C206.717 152.595 206.794 152.497 206.908 152.473L248.852 143.557C248.966 143.533 249.076 143.591 249.097 143.687L249.208 144.212C249.228 144.308 249.152 144.406 249.038 144.43Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.444 137.509L206.345 149.858C206.231 149.882 206.121 149.823 206.101 149.728L205.989 149.203C205.969 149.107 206.046 149.009 206.16 148.984L264.258 136.635C264.372 136.611 264.482 136.67 264.503 136.765L264.614 137.29C264.634 137.386 264.558 137.484 264.444 137.509Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.46 127.914L213.324 134.957C213.223 134.978 213.125 134.926 213.107 134.841L212.987 134.278C212.969 134.192 213.037 134.105 213.139 134.084L246.275 127.04C246.376 127.019 246.474 127.071 246.492 127.156L246.612 127.719C246.63 127.805 246.562 127.892 246.46 127.914Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.968 113.054L202.245 123.623C202.158 123.641 202.074 123.597 202.059 123.524L201.93 122.916C201.914 122.843 201.972 122.768 202.059 122.75L251.783 112.181C251.87 112.162 251.953 112.207 251.969 112.279L252.098 112.888C252.114 112.961 252.055 113.035 251.968 113.054Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.013 118.005L203.29 128.574C203.203 128.593 203.119 128.548 203.104 128.475L202.974 127.867C202.959 127.794 203.017 127.72 203.104 127.701L252.828 117.132C252.915 117.114 252.998 117.158 253.014 117.231L253.143 117.839C253.159 117.912 253.1 117.987 253.013 118.005Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.888 122.075L204.165 132.644C204.078 132.662 203.994 132.618 203.979 132.545L203.849 131.937C203.834 131.864 203.892 131.789 203.979 131.771L253.703 121.202C253.79 121.183 253.873 121.228 253.889 121.3L254.018 121.909C254.034 121.982 253.975 122.056 253.888 122.075Z",
    fill: "#EA92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.345 173.96L187.006 130.023L236.525 151.168L273.163 111.71L282.502 155.647L196.345 173.96Z",
    fill: "#FFBE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.502 155.647L196.345 173.96L232.779 143.576C234.323 142.288 236.408 141.861 238.335 142.437L282.502 155.647Z",
    fill: "#FFCD7D"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.03 161.097L243.674 157.455C244.519 157.432 245.361 157.575 246.15 157.877C246.94 158.178 247.662 158.633 248.276 159.214C248.89 159.795 249.384 160.491 249.729 161.262C250.074 162.034 250.263 162.866 250.287 163.711L263.84 302.983C263.887 304.689 263.254 306.345 262.081 307.585C260.908 308.825 259.29 309.548 257.584 309.595L125.939 313.237C124.233 313.285 122.577 312.652 121.337 311.479C120.097 310.306 119.374 308.688 119.327 306.981L105.774 167.71C105.727 166.003 106.359 164.348 107.532 163.108C108.706 161.868 110.323 161.145 112.03 161.097Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.03 161.097L243.674 157.455C244.519 157.432 245.361 157.575 246.15 157.877C246.94 158.178 247.662 158.633 248.276 159.214C248.89 159.795 249.384 160.491 249.729 161.262C250.074 162.034 250.263 162.866 250.287 163.711L253.929 295.356C253.976 297.062 253.344 298.717 252.17 299.957C250.997 301.197 249.379 301.921 247.673 301.968L116.028 305.61C114.322 305.657 112.667 305.025 111.427 303.852C110.187 302.678 109.463 301.06 109.416 299.354L105.774 167.71C105.727 166.003 106.359 164.348 107.532 163.108C108.706 161.868 110.323 161.145 112.03 161.097Z",
    fill: "#FFF3E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.987 179.766C156.306 178.698 199.625 177.63 242.944 176.561",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.713 191.598C157.032 190.53 200.351 189.461 243.67 188.393",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.031 203.177C157.35 202.108 200.669 201.04 243.988 199.972",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.631 214.984C157.95 213.916 201.269 212.847 244.588 211.779",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.681 226.763C158 225.695 201.319 224.627 244.638 223.559",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.022 239.053C159.342 237.984 202.661 236.916 245.98 235.848",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.331 250.291C158.65 249.222 201.969 248.154 245.288 247.086",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.68 262.608C158.999 261.54 202.318 260.472 245.637 259.404",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.99 273.839C159.309 272.771 202.628 271.703 245.947 270.634",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.325 286.025C159.644 284.957 202.963 283.889 246.282 282.82",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.646 297.506C159.965 296.438 203.284 295.37 246.603 294.301",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.07 168.41C156.389 167.342 199.708 166.274 243.027 165.205",
    stroke: "#FFDE4F",
    strokeOpacity: 0.51,
    strokeWidth: 0.780795,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M206.272 288.342C205.173 288.84 203.944 288.977 202.762 288.733C200.808 288.585 198.827 288.028 197.084 289.513C196.621 289.907 196.211 289.579 195.881 289.154C194.896 287.883 193.691 288.094 192.51 288.773C190.885 289.705 189.604 291.137 188.857 292.855C188.665 293.281 188.635 293.927 188 293.789C187.259 293.629 187.499 292.964 187.542 292.444C187.572 292.085 187.61 291.728 187.639 291.369C187.673 291.222 187.676 291.069 187.649 290.921C187.622 290.772 187.565 290.631 187.482 290.505C187.399 290.379 187.29 290.271 187.164 290.188C187.038 290.105 186.896 290.049 186.747 290.022C186.154 289.887 185.595 289.821 185.165 290.472C184.785 291.011 184.348 291.507 183.862 291.951C183.494 292.308 183.064 292.87 182.502 292.389C182.063 292.014 182.405 291.493 182.614 291.073C183.209 289.838 184.182 288.825 185.392 288.18C184.935 287.397 184.11 288.111 183.688 287.383C184.408 286.91 185.395 287.103 186.054 286.489C186.264 286.293 186.821 286.379 186.727 286.703C186.16 288.673 188.727 288.523 188.762 290.129C189.726 289.146 190.814 288.292 191.997 287.588C193.458 286.861 194.955 286.431 196.348 287.677C196.859 288.134 197.28 287.958 197.819 287.864C200.668 287.37 203.448 288.244 206.272 288.342Z",
    fill: "#313173"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.536 174.54C145.635 174.041 146.864 173.904 148.046 174.148C150.001 174.295 151.981 174.852 153.724 173.367C154.187 172.973 154.597 173.301 154.927 173.726C155.913 174.996 157.117 174.785 158.298 174.106C159.923 173.173 161.204 171.742 161.951 170.024C162.142 169.597 162.172 168.952 162.808 169.089C163.548 169.249 163.308 169.914 163.265 170.434C163.236 170.792 163.198 171.15 163.168 171.509C163.135 171.656 163.131 171.809 163.159 171.957C163.186 172.106 163.243 172.247 163.326 172.373C163.41 172.499 163.518 172.607 163.644 172.69C163.77 172.773 163.912 172.829 164.061 172.855C164.654 172.99 165.214 173.057 165.643 172.405C166.023 171.867 166.46 171.371 166.946 170.926C167.313 170.569 167.743 170.007 168.306 170.488C168.745 170.863 168.403 171.384 168.194 171.803C167.599 173.039 166.626 174.052 165.417 174.698C165.874 175.481 166.699 174.766 167.12 175.494C166.401 175.967 165.414 175.775 164.755 176.389C164.545 176.584 163.988 176.499 164.082 176.175C164.649 174.205 162.082 174.355 162.046 172.749C161.082 173.732 159.995 174.586 158.812 175.291C157.35 176.019 155.854 176.449 154.461 175.202C153.95 174.745 153.529 174.922 152.989 175.016C150.141 175.511 147.361 174.637 144.536 174.54Z",
    fill: "#313173"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M211.841 287.031C213.293 285.872 213.098 283.735 214.51 282.327C215.179 283.557 214.446 284.67 214.714 285.969C215.539 285.352 216.229 284.572 216.739 283.677C217.309 282.879 217.803 282.644 218.151 283.813C218.423 284.73 218.66 285.657 218.905 286.581C219 286.937 219.07 287.357 218.655 287.513C218.062 287.736 217.976 287.197 217.86 286.819C217.672 286.208 217.531 285.582 217.315 284.746C216.542 285.572 215.929 286.277 215.262 286.928C214.459 287.711 213.546 288.732 213.56 286.253C212.711 287.322 212.287 288.56 210.884 288.336C210.306 288.244 209.456 288.26 209.668 287.222C210.366 286.856 211.121 287.146 211.841 287.031Z",
    fill: "#39397C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.97 175.85C137.518 177.01 137.713 179.147 136.302 180.555C135.632 179.326 136.365 178.213 136.097 176.913C135.271 177.53 134.582 178.311 134.072 179.206C133.502 180.004 133.008 180.239 132.66 179.07C132.388 178.154 132.151 177.227 131.905 176.303C131.811 175.946 131.74 175.526 132.156 175.37C132.748 175.147 132.834 175.686 132.95 176.064C133.139 176.675 133.279 177.301 133.496 178.137C134.268 177.311 134.882 176.605 135.548 175.955C136.351 175.171 137.264 174.15 137.25 176.629C138.099 175.56 138.523 174.322 139.926 174.545C140.504 174.637 141.355 174.621 141.142 175.659C140.445 176.026 139.689 175.736 138.97 175.85Z",
    fill: "#39397C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.557 289.068C169.482 289.02 169.403 288.976 169.322 288.937C169.22 288.823 169.153 288.682 169.128 288.53C169.103 288.379 169.122 288.224 169.182 288.083C169.236 288.026 169.274 287.955 169.291 287.877C171.247 288.311 173.112 288.543 174.904 287.145C175.827 286.425 178.36 287.366 178.824 288.364C178.876 288.472 178.889 288.594 178.862 288.711C178.835 288.827 178.77 288.931 178.676 289.005C178.582 289.079 178.466 289.119 178.347 289.119C178.227 289.118 178.111 289.077 178.018 289.002C176.262 287.873 174.698 288.318 173.046 289.348C171.931 290.043 170.75 288.923 169.557 289.068Z",
    fill: "#3A397B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M181.252 173.804C181.328 173.853 181.407 173.897 181.488 173.935C181.59 174.05 181.657 174.191 181.682 174.342C181.706 174.493 181.688 174.648 181.628 174.789C181.574 174.847 181.536 174.918 181.519 174.996C179.563 174.562 177.698 174.331 175.906 175.729C174.984 176.449 172.45 175.508 171.986 174.51C171.934 174.403 171.921 174.281 171.948 174.164C171.974 174.048 172.04 173.944 172.134 173.87C172.227 173.795 172.344 173.755 172.463 173.756C172.583 173.756 172.698 173.797 172.791 173.873C174.548 175.001 176.112 174.556 177.764 173.526C178.879 172.83 180.06 173.95 181.252 173.804Z",
    fill: "#3A397B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.477 282.274C235.624 282.829 233.452 285.067 236.053 284.746C236.147 285.398 235.656 285.636 235.273 285.988C234.619 286.588 233.944 284.92 233.303 286.066C233.06 286.744 232.611 287.329 232.019 287.739C231.878 286.463 233.151 283.661 234.477 282.274Z",
    fill: "#3D3C7E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.334 180.612C115.187 180.057 117.359 177.819 114.758 178.14C114.664 177.489 115.155 177.25 115.538 176.898C116.192 176.298 116.867 177.966 117.508 176.819C117.75 176.141 118.199 175.556 118.791 175.146C118.932 176.423 117.661 179.225 116.334 180.612Z",
    fill: "#3D3C7E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M223.419 286.71C225.524 286.988 226.575 287.927 226.287 289.28C226.214 289.621 226.161 290.013 225.7 290.043C225.549 290.057 225.399 290.012 225.28 289.918C225.161 289.824 225.082 289.688 225.06 289.538C224.766 287.709 223.575 287.659 222.148 288.015C221.76 288.112 221.227 288.295 221.09 287.777C220.935 287.193 221.666 287.337 221.923 287.058C222.347 286.622 222.896 286.723 223.419 286.71Z",
    fill: "#343478"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.383 176.178C125.278 175.899 124.227 174.96 124.514 173.607C124.587 173.266 124.64 172.875 125.101 172.844C125.252 172.831 125.402 172.876 125.521 172.97C125.64 173.064 125.719 173.199 125.741 173.349C126.036 175.179 127.226 175.229 128.653 174.872C129.041 174.774 129.574 174.591 129.712 175.11C129.867 175.694 129.135 175.55 128.879 175.829C128.454 176.265 127.905 176.164 127.383 176.178Z",
    fill: "#343478"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.924 216.894C131.399 216.505 117.565 228.469 117.565 228.469L118.802 266.142L250.493 261.816L248.902 213.379C248.902 213.379 239.004 220.46 232.062 219.54C220.981 218.071 226.589 198.862 215.785 195.995C207.959 193.919 203.233 203.424 195.599 200.726C187.918 198.013 190.168 187.797 182.852 184.213C166.305 176.107 181.35 226.734 162.926 226.979C153.828 227.1 151.016 217.229 141.924 216.894Z",
    fill: "url(#paint0_linear_871_27548)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M117.565 228.469C117.565 228.469 131.399 216.505 141.924 216.894C151.016 217.229 153.828 227.1 162.926 226.979C181.35 226.734 166.305 176.107 182.852 184.213C190.168 187.797 187.918 198.013 195.599 200.726C203.233 203.424 207.959 193.919 215.785 195.995C226.589 198.862 220.981 218.071 232.062 219.54C239.004 220.46 248.902 213.379 248.902 213.379",
    stroke: "url(#paint1_linear_871_27548)",
    strokeWidth: 0.506054,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M116.668 204.854C116.668 204.854 127.902 212.473 135.362 211.606C144.68 210.523 144.752 197.249 154.11 196.586C165.226 195.799 165.788 217.522 176.463 214.324C182.459 212.528 182.052 205.202 187.972 203.171C198.233 199.649 201.67 218.189 212.377 216.443C221.222 215 220.674 201.348 229.541 200.046C237.13 198.931 239.896 203.994 248.762 206.121",
    stroke: "url(#paint2_linear_871_27548)",
    strokeWidth: 0.506054,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.473 270.102C129.314 270.107 129.219 270.013 129.207 269.877L129.206 269.87L129.337 269.866L129.338 269.871C129.346 269.936 129.388 269.986 129.468 269.983C129.555 269.98 129.601 269.927 129.598 269.829L129.578 269.228L129.711 269.223L129.731 269.826C129.736 269.994 129.64 270.096 129.473 270.102ZM130.055 270.08C129.93 270.084 129.844 270.01 129.84 269.898L129.84 269.897C129.837 269.788 129.919 269.719 130.066 269.705L130.235 269.69L130.234 269.643C130.231 269.574 130.186 269.534 130.106 269.537C130.032 269.539 129.988 269.576 129.979 269.626L129.978 269.631L129.857 269.635L129.857 269.629C129.862 269.521 129.953 269.436 130.106 269.431C130.259 269.426 130.358 269.503 130.362 269.628L130.376 270.058L130.247 270.062L130.244 269.964L130.242 269.964C130.208 270.032 130.137 270.077 130.055 270.08ZM129.97 269.891C129.971 269.945 130.017 269.978 130.086 269.976C130.176 269.973 130.242 269.91 130.24 269.828L130.238 269.78L130.086 269.794C130.009 269.802 129.968 269.837 129.969 269.89L129.97 269.891ZM130.501 270.054L130.48 269.43L130.608 269.426L130.611 269.52L130.614 269.52C130.645 269.456 130.707 269.411 130.802 269.408C130.938 269.403 131.02 269.489 131.025 269.632L131.038 270.036L130.91 270.04L130.897 269.661C130.894 269.567 130.848 269.516 130.76 269.519C130.669 269.522 130.613 269.589 130.617 269.686L130.629 270.05L130.501 270.054Z",
    fill: "#454459"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M202.138 267.703L202.11 266.848L202.264 266.843L202.563 267.516L202.567 267.516L202.822 266.824L202.975 266.819L203.003 267.675L202.882 267.678L202.861 267.047L202.857 267.047L202.62 267.687L202.521 267.69L202.243 267.068L202.239 267.068L202.259 267.699L202.138 267.703ZM203.312 267.676C203.187 267.68 203.101 267.606 203.098 267.494L203.098 267.493C203.094 267.384 203.176 267.315 203.323 267.301L203.492 267.286L203.491 267.239C203.489 267.17 203.443 267.13 203.363 267.133C203.289 267.135 203.245 267.172 203.236 267.222L203.235 267.227L203.114 267.231L203.114 267.225C203.12 267.117 203.21 267.032 203.363 267.027C203.516 267.022 203.615 267.099 203.619 267.224L203.633 267.654L203.505 267.658L203.501 267.56L203.499 267.56C203.465 267.628 203.394 267.673 203.312 267.676ZM203.227 267.487C203.229 267.541 203.275 267.574 203.343 267.572C203.434 267.569 203.5 267.506 203.497 267.424L203.495 267.376L203.343 267.39C203.267 267.398 203.225 267.433 203.227 267.486L203.227 267.487ZM203.837 267.855C203.812 267.856 203.785 267.854 203.77 267.852L203.766 267.751C203.777 267.754 203.792 267.755 203.809 267.755C203.869 267.753 203.902 267.736 203.921 267.675L203.931 267.645L203.683 267.028L203.822 267.023L203.996 267.526L204 267.525L204.14 267.013L204.275 267.008L204.065 267.669C204.023 267.799 203.959 267.851 203.837 267.855Z",
    fill: "#454459"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M147.362 269.498L147.334 268.643L147.868 268.626L147.872 268.74L147.47 268.753L147.479 269.024L147.847 269.012L147.851 269.124L147.483 269.136L147.495 269.494L147.362 269.498ZM148.241 269.482C148.058 269.488 147.943 269.367 147.937 269.17L147.937 269.169C147.93 268.974 148.039 268.84 148.214 268.834C148.389 268.829 148.5 268.951 148.506 269.138L148.507 269.181L148.066 269.196C148.072 269.314 148.139 269.38 148.241 269.377C148.317 269.374 148.366 269.334 148.38 269.286L148.382 269.282L148.504 269.278L148.503 269.284C148.486 269.384 148.393 269.477 148.241 269.482ZM148.218 268.939C148.135 268.942 148.073 269 148.065 269.105L148.378 269.095C148.363 268.987 148.301 268.936 148.218 268.939ZM148.948 269.459C148.858 269.462 148.788 269.419 148.749 269.347L148.746 269.347L148.749 269.453L148.621 269.457L148.593 268.602L148.721 268.598L148.732 268.935L148.735 268.935C148.77 268.861 148.84 268.814 148.928 268.811C149.084 268.806 149.192 268.927 149.198 269.125L149.198 269.126C149.205 269.325 149.106 269.454 148.948 269.459ZM148.911 269.35C149.011 269.346 149.071 269.263 149.067 269.13L149.067 269.13C149.063 268.998 148.997 268.918 148.897 268.922C148.8 268.925 148.734 269.011 148.738 269.14L148.738 269.141C148.742 269.271 148.813 269.353 148.911 269.35Z",
    fill: "#454459"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.669 268.896L165.641 268.041L165.795 268.036L166.094 268.709L166.097 268.709L166.352 268.017L166.505 268.012L166.533 268.868L166.412 268.872L166.392 268.24L166.388 268.241L166.15 268.88L166.052 268.884L165.773 268.261L165.769 268.261L165.79 268.892L165.669 268.896ZM166.842 268.869C166.718 268.873 166.632 268.799 166.628 268.687L166.628 268.686C166.625 268.578 166.707 268.508 166.854 268.495L167.023 268.479L167.022 268.432C167.019 268.363 166.973 268.323 166.894 268.326C166.82 268.328 166.775 268.365 166.766 268.415L166.765 268.42L166.645 268.424L166.645 268.418C166.65 268.31 166.741 268.225 166.894 268.22C167.046 268.215 167.146 268.292 167.15 268.417L167.164 268.847L167.035 268.851L167.032 268.753L167.03 268.753C166.996 268.821 166.925 268.866 166.842 268.869ZM166.757 268.68C166.759 268.735 166.805 268.767 166.874 268.765C166.964 268.762 167.03 268.699 167.028 268.618L167.026 268.569L166.874 268.584C166.797 268.591 166.756 268.626 166.757 268.679L166.757 268.68ZM167.288 268.843L167.268 268.219L167.396 268.215L167.399 268.322L167.402 268.322C167.42 268.248 167.471 268.201 167.542 268.199C167.56 268.198 167.576 268.2 167.587 268.202L167.591 268.321C167.58 268.317 167.558 268.315 167.533 268.316C167.45 268.318 167.401 268.374 167.404 268.467L167.416 268.839L167.288 268.843Z",
    fill: "#454459"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M220.937 267.094C220.778 267.099 220.683 267.005 220.671 266.869L220.67 266.862L220.801 266.858L220.802 266.863C220.809 266.928 220.852 266.978 220.931 266.975C221.019 266.972 221.065 266.919 221.062 266.821L221.042 266.22L221.175 266.215L221.195 266.818C221.2 266.986 221.104 267.088 220.937 267.094ZM221.559 267.071C221.423 267.076 221.341 266.99 221.337 266.847L221.323 266.443L221.451 266.438L221.464 266.818C221.467 266.912 221.513 266.963 221.601 266.96C221.692 266.957 221.748 266.89 221.744 266.793L221.732 266.429L221.861 266.425L221.881 267.048L221.753 267.053L221.75 266.959L221.747 266.959C221.716 267.023 221.654 267.068 221.559 267.071ZM222.008 267.044L221.988 266.421L222.116 266.417L222.119 266.511L222.122 266.511C222.152 266.446 222.215 266.401 222.309 266.398C222.446 266.394 222.528 266.48 222.533 266.623L222.546 267.027L222.417 267.031L222.405 266.651C222.402 266.558 222.356 266.507 222.267 266.509C222.177 266.512 222.121 266.58 222.124 266.677L222.136 267.04L222.008 267.044Z",
    fill: "#454459"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M183.892 268.298L184.17 267.432L184.342 267.427L184.676 268.272L184.515 268.277L184.436 268.059L184.118 268.069L184.053 268.293L183.892 268.298ZM184.259 267.582L184.152 267.95L184.393 267.942L184.263 267.582L184.259 267.582ZM184.759 268.477L184.732 267.641L184.879 267.636L184.883 267.745L184.886 267.745C184.92 267.668 184.987 267.62 185.077 267.617C185.236 267.612 185.341 267.733 185.348 267.936L185.348 267.936C185.355 268.138 185.258 268.265 185.1 268.271C185.011 268.274 184.938 268.231 184.9 268.159L184.897 268.159L184.907 268.472L184.759 268.477ZM185.051 268.148C185.145 268.145 185.201 268.065 185.197 267.941L185.197 267.94C185.193 267.815 185.131 267.74 185.037 267.743C184.946 267.746 184.885 267.827 184.889 267.951L184.889 267.951C184.893 268.074 184.959 268.151 185.051 268.148ZM185.453 268.247L185.432 267.618L185.58 267.613L185.584 267.722L185.587 267.722C185.604 267.645 185.654 267.598 185.727 267.596C185.745 267.595 185.762 267.597 185.774 267.6L185.778 267.733C185.765 267.729 185.743 267.726 185.718 267.727C185.634 267.73 185.586 267.784 185.589 267.877L185.601 268.242L185.453 268.247Z",
    fill: "#454459"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.929 266.508C238.771 266.513 238.675 266.42 238.664 266.284L238.663 266.277L238.794 266.272L238.795 266.278C238.802 266.343 238.845 266.392 238.924 266.39C239.012 266.387 239.058 266.333 239.054 266.235L239.035 265.634L239.167 265.63L239.187 266.232C239.193 266.4 239.097 266.503 238.929 266.508ZM239.552 266.486C239.415 266.49 239.334 266.405 239.329 266.261L239.316 265.857L239.444 265.853L239.457 266.232C239.46 266.326 239.505 266.377 239.594 266.374C239.684 266.371 239.74 266.305 239.737 266.207L239.725 265.844L239.854 265.839L239.874 266.463L239.745 266.467L239.742 266.373L239.739 266.373C239.709 266.437 239.647 266.483 239.552 266.486ZM240.006 266.459L239.978 265.603L240.106 265.599L240.134 266.454L240.006 266.459Z",
    fill: "#454459"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M129.98 265.113L127.093 177.246",
    stroke: "#171724",
    strokeWidth: 0.101211,
    strokeLinecap: "round",
    strokeDasharray: "0 0.1 1.42 0 0.1 1.42"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.101 264.517L145.214 176.65",
    stroke: "#171724",
    strokeWidth: 0.101211,
    strokeLinecap: "round",
    strokeDasharray: "0 0.1 1.42 0 0.1 1.42"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.223 263.92L163.336 176.053",
    stroke: "#171724",
    strokeWidth: 0.101211,
    strokeLinecap: "round",
    strokeDasharray: "0 0.1 1.42 0 0.1 1.42"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M184.363 263.986L181.477 176.119",
    stroke: "#171724",
    strokeWidth: 0.101211,
    strokeLinecap: "round",
    strokeDasharray: "0 0.1 1.42 0 0.1 1.42"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M202.485 263.389L199.599 175.522",
    stroke: "#171724",
    strokeWidth: 0.101211,
    strokeLinecap: "round",
    strokeDasharray: "0 0.1 1.42 0 0.1 1.42"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M220.607 262.793L217.721 174.926",
    stroke: "#171724",
    strokeWidth: 0.101211,
    strokeLinecap: "round",
    strokeDasharray: "0 0.1 1.42 0 0.1 1.42"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M238.73 262.196L235.843 174.329",
    stroke: "#171724",
    strokeWidth: 0.101211,
    strokeLinecap: "round",
    strokeDasharray: "0 0.1 1.42 0 0.1 1.42"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_871_27548)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 181.717,
    cy: 183.369,
    r: 4.39573,
    transform: "rotate(-1.8817 181.717 183.369)",
    fill: "url(#paint3_linear_871_27548)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.717,
    cy: 183.369,
    r: 3.99088,
    transform: "rotate(-1.8817 181.717 183.369)",
    stroke: "white",
    strokeWidth: 0.809687
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_871_27548",
    x: 174.791,
    y: 176.949,
    width: 13.8525,
    height: 13.852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.506054
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26514
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_871_27548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_871_27548",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_871_27548",
    x1: 181.996,
    y1: 183.255,
    x2: 184.648,
    y2: 263.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9364",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25F33",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_871_27548",
    x1: 181.996,
    y1: 183.255,
    x2: 183.41,
    y2: 226.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25F33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_871_27548",
    x1: 182.392,
    y1: 195.651,
    x2: 183.109,
    y2: 217.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B09FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D79F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_871_27548",
    x1: 181.717,
    y1: 178.973,
    x2: 181.717,
    y2: 187.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25F33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_27548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 292,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_871_27548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.674,
    height: 199.674,
    fill: "white",
    transform: "translate(82.5752 93.8792) rotate(-6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_871_27548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.882,
    height: 199.882,
    fill: "white",
    transform: "translate(82.7666 94.0344) rotate(-6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_871_27548"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.115,
    y: 102.308,
    width: 88.0815,
    height: 73.2524,
    rx: 4,
    transform: "rotate(-12 181.115 102.308)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigntrack);
export default __webpack_public_path__ + "static/media/campaigntrack.76eec5b4fd95e744ac6204b36b719795.svg";
export { ForwardRef as ReactComponent };